<template>
  <f7-page name="profilePage">
    <div id="profile-page" class="profile-content">
      <div class="sub-menu-wrapper">
        <SubMenu :items="MenuOptions.contexts.clientArea.items" />
      </div>
      <ClientArea :key="clientAreaKey" />
    </div>
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ClientArea from '@/components/ClientArea/index.vue';
import SubMenu from '@/components/SubMenu/index.vue';
import MenuOptions from '@/json/menuOptions.json';

export default {
  name: 'ClientAreaPage',
  components: {
    ClientArea,
    SubMenu,
  },
  data() {
    return {
      MenuOptions,
      clientAreaKey: 0,
    };
  },
  computed: {
    ...mapState('contact', ['company']),
  },
  watch: {
    company() {
      this.clientAreaKey += 1;
    },
  },
  async mounted() {
    this.setCurrentRoute([
      {
        name: this.$t('clientArea'),
        disabled: false,
        page: 'ClientAreaPage',
        active: true,
      },
    ]);
    await this.getUsers();
  },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('company', ['getUsers']),
  },
};
</script>
<style lang="scss">
#profile-page {
  .sub-menu-wrapper {
    padding-bottom: 24px;
    border-bottom: 2px solid #c2d8f0;
    margin-bottom: 24px;
  }
}
</style>
